const jsLoader = {
	load: (src, callback) => {
		let script = document.createElement('script');
		let loaded;
		script.setAttribute('src', src);
		if (callback) {
			script.onreadystatechange = () => {
				if (!loaded) {
					callback();
				}
				loaded = true;
			};
			script.onload = script.onreadystatechange;
		}
		document.getElementsByTagName('head')[0].appendChild(script);
	}
};
module.exports = jsLoader;


// WEBPACK FOOTER //
// ./lib/jsLoader.js